<template>
    <div class="row g-6 mb-6" v-if="normalizedCards.length">
        <div v-for="(card, index) in normalizedCards" :key="`${card.title}-${index}`" class="col-xl-3 col-sm-6">
            <div class="card h-100" :class="`card-border-shadow-${card.tone}`">
                <div class="card-body">
                    <div class="d-flex align-items-center mb-2">
                        <div class="avatar me-4">
                            <span class="avatar-initial rounded" :class="`bg-label-${card.tone}`">
                                <i :class="[card.icon || 'ti ti-chart-bar', 'ti-28px']"></i>
                            </span>
                        </div>
                        <h4 class="mb-0">{{ formatValue(card.value) }}</h4>
                    </div>
                    <p class="mb-0">
                        <span class="text-heading fw-medium me-2">{{ card.title }}</span>
                    </p>
                    <small v-if="card.subtitle" class="text-muted d-block mt-1">{{ card.subtitle }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OverviewStats',
    props: {
        cards: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        normalizedCards() {
            return (this.cards || []).filter(card => card && card.title);
        },
    },
    methods: {
        formatValue(value) {
            if (typeof value === 'number') {
                return new Intl.NumberFormat('en-US').format(value);
            }

            if (value === null || value === undefined || value === '') {
                return 0;
            }

            return value;
        },
    },
};
</script>
